// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__1Y4YO"};